import React from 'react'
import Navbar from '../components/Navbar/Navbar'
import Header from '../components/Home/Header'
import WhyChooseUs from '../components/Home/WhyChooseUs'
import Detailed from '../components/Home/Detailed'
import Servicehome from '../components/Home/Servicehome'
import Commitment from '../components/Home/Commitment'
import Footer from '../components/Footer/Footer'
import ClientTestimonials from '../components/Home/ClientTestimonial'
import WasteManagement from '../components/Home/WasteManagement'
import ServiceGrid from '../components/Home/ServiceGrid'

const Homepage = () => {
    return (
        <div>
            <Navbar />
            <Header />
            <WasteManagement/>
            
            <ServiceGrid/>
         
            <Commitment/>
            <ClientTestimonials/>
            <Footer/>

        </div>
    )
}

export default Homepage